
import APIClient from './APIClient'

class CAuthAPI {

  async employeeLogin(id_code) {
    const res = await APIClient.POST('/auth/employee', { id_code })
    return res
  }

}

const AuthAPI = new CAuthAPI()

export default AuthAPI



// WEBPACK FOOTER //
// ./src/api/AuthAPI.js